import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const STEPS = [
  ["Lag eller åpne dokumentet", "Bruk Google Sheets (anbefalt) eller et Google Dokument med en tabell. Første rad skal inneholde kolonnenavn, for eksempel Skip, Ankomstdato, Ankomsttid, Avgangsdato, Avgangstid, Kai, Skipstype og Status."],
  ["Del dokumentet offentlig", "Trykk «Del» øverst til høyre i Google. Under «Generell tilgang» velger du «Alle med lenken» og rollen «Leser». Kopier lenken."],
  ["Lim inn lenken her", "Lim inn lenken under «Datakilde» og trykk «Hent og lagre». Vi viser hvor mange anløp vi fant og hvilke kolonner vi kjente igjen."],
  ["Kopier embed-koden", "Lim inn koden i en HTML-widget på nettsiden (WordPress/Elementor: «HTML»-widget). Bruk «Full anløpsliste» på egen side og «Neste anløp» på forsiden."],
  ["Oppdater som vanlig i Google", "Endringer i dokumentet vises på nettsiden innen 5 minutter. Trykk «Oppdater nå» hvis du vil se det med en gang."],
];

const TIPS = [
  "Kolonnene Ankomst, Skip, Skipstype, Kai og Avgang vises alltid først. Alle andre kolonner vises når besøkende åpner en rad.",
  "Vi kjenner igjen vanlige navn på norsk og engelsk: Ankomst/Arrival/ETA, Skip/Vessel/Ship, Kai/Berth/Quay, Avgang/Departure/ETD og Status.",
  "Datoer kan skrives som 24.10.2026, 24.10.26, 2026-10-24 eller 24. oktober 2026. Klokkeslett som 08:00, 08.00 eller 0800.",
  "Har du ingen statuskolonne, regner vi ut status selv: Forventet, I havnen eller Avgått. Skriver du f.eks. «Kansellert», brukes den.",
  "Listen viser anløp fra i dag og fremover. Besøkende kan velge tidligere datoer i filteret.",
  "Er dokumentet privat eller tomt, beholder nettsiden siste vellykkede versjon og du får en feilmelding her.",
];

export const AnlopDocs = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="anlop-docs-dialog">
      <DialogHeader>
        <DialogTitle className="font-display text-xl">Slik bruker du anløpslisten</DialogTitle>
        <DialogDescription>Fem steg fra Google-dokument til live anløpsliste på nettsiden.</DialogDescription>
      </DialogHeader>
      <ol className="space-y-4 mt-2">
        {STEPS.map(([t, d], i) => (
          <li key={t} className="flex gap-3">
            <span className="w-7 h-7 shrink-0 rounded-full bg-sky-100 text-sky-900 text-sm font-semibold flex items-center justify-center">{i + 1}</span>
            <div><div className="font-medium text-slate-900">{t}</div><p className="text-sm text-slate-600 mt-0.5">{d}</p></div>
          </li>
        ))}
      </ol>
      <div className="mt-4 rounded-md bg-slate-50 border border-slate-200 p-4">
        <div className="text-sm font-semibold text-slate-900 mb-2">Godt å vite</div>
        <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-600">{TIPS.map((t) => <li key={t}>{t}</li>)}</ul>
      </div>
    </DialogContent>
  </Dialog>
);
